export default __webpack_public_path__ + "static/bg-c5638708e78619090c56f66594416f53.svg";